/* cache-buster: 1779732500 */
/* =============================================================================
   Maskaľ Cookies — GDPR consent banner v2.3
   Vanilla JS, zero dependencies.
   Integration: GTM Consent Mode v2 (dataLayer) + Shopify Customer Privacy API.
   v2.1 changes: cookie cleanup on category downgrade (granted -> denied)
                  wipes vendor cookies on both bare and dotted domains.
   v2.2 changes: delayed second cleanup pass at +1500ms covers Shopify pixel
                  sandbox race condition (it re-creates _fbp ~7ms after we wipe).
   v2.3 changes: on every page load, if a category is denied in stored consent,
                  wipe its cookies too (Shopify pixel re-creates _fbp on each load).
   =========================================================================== */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Config
  // ---------------------------------------------------------------------------
  var STORAGE_KEY = 'maskal_cookie_consent_v2';
  var CONSENT_VERSION = 2;
  var REOPEN_HASH = '#cookie-settings';

  var CATS = [
    {
      id: 'necessary',
      label: 'Nevyhnutné',
      desc: 'Zaručujú základnú funkčnosť webu, košíka a bežných operácií.',
      locked: true,
      defaultOn: true
    },
    {
      id: 'analytics',
      label: 'Analýza návštevnosti',
      desc: 'Anonymné údaje o používaní webu, ktoré nám slúžia na zlepšovanie služieb.',
      locked: false,
      defaultOn: false
    },
    {
      id: 'meta_pixel',
      label: 'Meta Pixel',
      desc: 'Mera návštevnosť a výkonnosť oznámení na platformách Meta.',
      locked: false,
      defaultOn: false
    },
    {
      id: 'marketing',
      label: 'Reklama Google',
      desc: 'Personalizovaná reklama a remarketing v sieti Google.',
      locked: false,
      defaultOn: false
    }
  ];


  // Cookie names to wipe when a category downgrades from granted -> denied.
  // Suffix '*' = prefix match (e.g. '_ga_*' matches '_ga_GSLGB5SV97').
  var COOKIE_MAP = {
    analytics: ['_ga', '_gid', '_gat', '_ga_*', '_gac_*', '_hjSessionUser_*', '_hjSession_*', '_hjFirstSeen', '_hjIncludedInSessionSample_*', '_hjAbsoluteSessionInProgress', '_hjid', '_hjTLDTest'],
    marketing: ['_gcl_au', '_gcl_aw', '_gcl_gs', '_gcl_dc', '_gcl_gb', '_uetsid', '_uetvid'],
    meta_pixel: ['_fbp', '_fbc', 'fr']
  };

  var COPY = {
    eyebrow: 'Súkromie',
    title: 'Staráme sa o vaše súkromie',
    body: 'Klenotníctvo Maskaľ používa súbory cookies, aby zaručilo plynulú funkčnosť webu a mohlo vám predstaviť hodinky a šperky, ktoré najlepšie zodpovedajú vašej voľbe. Súhlas môžete kedykoľvek upraviť.',
    acceptAll: 'Prijať všetky',
    reject: 'Odmietnuť',
    settings: 'Nastavenia',
    settingsEyebrow: 'Nastavenia',
    settingsTitle: 'Vyberte si voľbu',
    save: 'Potvrdiť voľbu',
    rejectAll: 'Odmietnuť',
    privacy: 'Zásady ochrany osobných údajov',
    back: 'Späť',
    alwaysActive: 'Vždy aktívne',
    reopenLabel: 'Cookies'
  };

  // ---------------------------------------------------------------------------
  // Storage
  // ---------------------------------------------------------------------------
  function loadConsent() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (obj && obj.v === CONSENT_VERSION) return obj;
      return null;
    } catch (e) { return null; }
  }

  function saveConsent(prefs) {
    try {
      var payload = Object.assign({}, prefs, { ts: Date.now(), v: CONSENT_VERSION });
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      return payload;
    } catch (e) { return null; }
  }

  // ---------------------------------------------------------------------------
  // Cookie cleanup — wipes vendor cookies when a category downgrades.
  // Without this, browsers retain trackers after consent revocation (GDPR breach).
  // ---------------------------------------------------------------------------
  function getHostDomains() {
    var host = window.location.hostname;
    var parts = host.split('.');
    var domains = [host, '.' + host];
    if (parts.length > 2) {
      var root = parts.slice(-2).join('.');
      domains.push(root, '.' + root);
    }
    return domains;
  }

  function deleteCookie(name) {
    var domains = getHostDomains();
    var paths = ['/', window.location.pathname];
    var expired = 'Thu, 01 Jan 1970 00:00:00 GMT';
    domains.forEach(function (d) {
      paths.forEach(function (p) {
        document.cookie = name + '=; expires=' + expired + '; path=' + p + '; domain=' + d;
      });
    });
    paths.forEach(function (p) {
      document.cookie = name + '=; expires=' + expired + '; path=' + p;
    });
  }

  function wipeCategoryCookies(catId) {
    var patterns = COOKIE_MAP[catId];
    if (!patterns || !patterns.length) return;
    var currentCookies = document.cookie.split(';').map(function (c) {
      return c.split('=')[0].trim();
    }).filter(Boolean);
    patterns.forEach(function (pattern) {
      if (pattern.charAt(pattern.length - 1) === '*') {
        var prefix = pattern.slice(0, -1);
        currentCookies.forEach(function (cn) {
          if (cn.indexOf(prefix) === 0) deleteCookie(cn);
        });
      } else {
        deleteCookie(pattern);
      }
    });
  }

  function cleanupDowngrades(oldPrefs, newPrefs) {
    if (!oldPrefs) return;
    Object.keys(COOKIE_MAP).forEach(function (cat) {
      var wasGranted = !!oldPrefs[cat];
      var isGranted  = !!newPrefs[cat];
      if (wasGranted && !isGranted) wipeCategoryCookies(cat);
    });
  }

  // ---------------------------------------------------------------------------
  // Tracking integration — dual signal
  // ---------------------------------------------------------------------------
  function applyConsent(prefs) {
    // — Google Consent Mode v2 — direct gtag() call —
    // Bypasses GTM tag configuration; updates consent state immediately.
    // This ensures GA4 / Google Ads attribution works even without a GTM
    // Consent Update tag being configured.
    try {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag('consent', 'update', {
        analytics_storage:    prefs.analytics ? 'granted' : 'denied',
        ad_storage:           prefs.marketing ? 'granted' : 'denied',
        ad_user_data:         prefs.marketing ? 'granted' : 'denied',
        ad_personalization:   prefs.marketing ? 'granted' : 'denied',
        functionality_storage: 'granted',
        security_storage:     'granted'
      });
    } catch (e) { /* swallow — gtag call must never throw */ }

    // — GTM custom event — for Meta Pixel tag condition only —
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'consent_update',
        mk_meta_pixel_consent: prefs.meta_pixel ? 'granted' : 'denied'
      });
    } catch (e) { /* swallow — dataLayer push must never throw */ }

    // — Shopify Customer Privacy API —
    // Controls Shopify-native pixels (Facebook & Instagram App, Google & YouTube App).
    // Called with a callback so Shopify can record the decision server-side.
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
      ) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics:    !!prefs.analytics,
            marketing:    !!(prefs.meta_pixel || prefs.marketing),
            preferences:  true,
            sale_of_data: !!(prefs.meta_pixel || prefs.marketing)
          },
          function () { /* Shopify recorded consent */ }
        );
      }
    } catch (e) { /* swallow */ }

    // Custom event — theme or other scripts can listen for this
    try {
      window.dispatchEvent(new CustomEvent('mk:consent', { detail: prefs }));
    } catch (e) { /* swallow */ }
  }

  // ---------------------------------------------------------------------------
  // DOM helpers
  // ---------------------------------------------------------------------------
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'class') {
          node.className = attrs[k];
        } else if (k === 'html') {
          node.innerHTML = attrs[k];
        } else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') {
          node.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
        } else if (k === 'aria') {
          Object.keys(attrs[k]).forEach(function (ak) {
            node.setAttribute('aria-' + ak, attrs[k][ak]);
          });
        } else if (k in node && k !== 'list') {
          try { node[k] = attrs[k]; } catch (e) { node.setAttribute(k, attrs[k]); }
        } else {
          node.setAttribute(k, attrs[k]);
        }
      });
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null) return;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  // ---------------------------------------------------------------------------
  // State
  // ---------------------------------------------------------------------------
  var state = {
    step: 'main',       // 'main' | 'settings'
    prefs: defaultPrefs(),
    open: false,
    hasConsent: false,
    root: null,
    backdrop: null
  };

  function defaultPrefs() {
    var p = {};
    CATS.forEach(function (c) { p[c.id] = c.defaultOn; });
    return p;
  }

  function prefsFromStored(stored) {
    var p = defaultPrefs();
    if (!stored) return p;
    CATS.forEach(function (c) {
      if (typeof stored[c.id] === 'boolean') p[c.id] = stored[c.id];
      if (c.locked) p[c.id] = true;
    });
    return p;
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  function renderShell() {
    if (state.root) return state.root;
    state.root = el('div', { class: 'mk-shell', id: 'mk-shell' });
    document.body.appendChild(state.root);
    return state.root;
  }

  function clearShell() {
    if (state.root) state.root.innerHTML = '';
    if (state.backdrop && state.backdrop.parentNode) {
      state.backdrop.parentNode.removeChild(state.backdrop);
    }
    state.backdrop = null;
  }

  function render() {
    var root = renderShell();
    clearShell();

    if (state.open) {
      // Backdrop — mobile only
      if (window.innerWidth <= 640) {
        state.backdrop = el('div', { class: 'mk-backdrop' });
        document.body.appendChild(state.backdrop);
      }

      // Card
      var anim = el('div', { class: 'mk-anim mk-anim--in' });
      var card = el('div', {
        class: 'mk-card',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': 'mk-title'
      });

      if (state.step === 'main') renderMain(card);
      else renderSettings(card);

      anim.appendChild(card);
      root.appendChild(anim);

      setTimeout(function () {
        var firstBtn = card.querySelector('.mk-btn--primary, .mk-back');
        if (firstBtn) firstBtn.focus();
      }, 30);

    } else if (state.hasConsent) {
      // Reopen badge
      var badge = el('button', {
        class: 'mk-reopen',
        type: 'button',
        'aria-label': 'Nastavenia cookies',
        onClick: function () { openCard('settings'); }
      }, [
        el('span', { class: 'mk-reopen-dot' }),
        document.createTextNode(COPY.reopenLabel)
      ]);
      root.appendChild(badge);
    }

  }

  function renderMain(card) {
    var step = el('div', { class: 'mk-step' });
    step.appendChild(el('div', { class: 'mk-eyebrow' }, COPY.eyebrow));
    step.appendChild(el('h2', { class: 'mk-title', id: 'mk-title' }, COPY.title));
    step.appendChild(el('p', { class: 'mk-body' }, COPY.body));

    var actions = el('div', { class: 'mk-actions' });

    var row = el('div', { class: 'mk-row' });
    row.appendChild(el('button', {
      class: 'mk-btn mk-btn--primary',
      type: 'button',
      onClick: rejectAll
    }, COPY.reject));
    row.appendChild(el('button', {
      class: 'mk-btn mk-btn--primary',
      type: 'button',
      onClick: acceptAll
    }, COPY.acceptAll));
    actions.appendChild(row);

    actions.appendChild(el('button', {
      class: 'mk-btn mk-btn--ghost',
      type: 'button',
      onClick: function () { state.step = 'settings'; render(); }
    }, COPY.settings));

    step.appendChild(actions);

    var foot = el('div', { class: 'mk-foot' });
    foot.appendChild(el('a', {
      class: 'mk-link',
      href: getPrivacyHref(),
      rel: 'noopener'
    }, COPY.privacy));
    step.appendChild(foot);

    card.appendChild(step);
  }

  function renderSettings(card) {
    var step = el('div', { class: 'mk-step' });

    step.appendChild(el('button', {
      class: 'mk-back',
      type: 'button',
      'aria-label': COPY.back,
      onClick: function () { state.step = 'main'; render(); }
    }, el('span', null, COPY.back)));

    step.appendChild(el('div', { class: 'mk-eyebrow' }, COPY.settingsEyebrow));
    step.appendChild(el('h2', { class: 'mk-title', id: 'mk-title' }, COPY.settingsTitle));

    var ul = el('ul', { class: 'mk-cats' });
    CATS.forEach(function (c) {
      var isOn = c.locked || !!state.prefs[c.id];
      var li = el('li', { class: 'mk-cat' + (c.locked ? ' is-locked' : '') });

      var textWrap = el('div', { class: 'mk-cat-text' });
      var labelEl = el('div', { class: 'mk-cat-label' }, c.label);
      if (c.locked) labelEl.appendChild(el('span', { class: 'mk-tag' }, COPY.alwaysActive));
      textWrap.appendChild(labelEl);
      textWrap.appendChild(el('div', { class: 'mk-cat-desc' }, c.desc));
      li.appendChild(textWrap);

      var tog = el('button', {
        class: 'mk-tog' + (isOn ? ' is-on' : ''),
        type: 'button',
        disabled: c.locked,
        'aria-label': c.label + ': ' + (isOn ? 'zapnuté' : 'vypnuté'),
        'aria-pressed': isOn ? 'true' : 'false',
        onClick: (function (cat) {
          return function () {
            if (cat.locked) return;
            state.prefs[cat.id] = !state.prefs[cat.id];
            render();
          };
        }(c))
      });
      tog.appendChild(el('span', { class: 'mk-tog-dot' }));
      li.appendChild(tog);

      ul.appendChild(li);
    });
    step.appendChild(ul);

    var actions = el('div', { class: 'mk-actions' });
    actions.appendChild(el('button', {
      class: 'mk-btn mk-btn--primary',
      type: 'button',
      onClick: saveSelection
    }, COPY.save));

    var row = el('div', { class: 'mk-row' });
    row.appendChild(el('button', {
      class: 'mk-btn mk-btn--ghost',
      type: 'button',
      onClick: rejectAll
    }, COPY.rejectAll));
    row.appendChild(el('button', {
      class: 'mk-btn mk-btn--ghost',
      type: 'button',
      onClick: acceptAll
    }, COPY.acceptAll));
    actions.appendChild(row);
    step.appendChild(actions);

    var foot = el('div', { class: 'mk-foot' });
    foot.appendChild(el('a', {
      class: 'mk-link',
      href: getPrivacyHref(),
      rel: 'noopener'
    }, COPY.privacy));
    foot.appendChild(el('span', { class: 'mk-version' }, 'v2.0'));
    step.appendChild(foot);

    card.appendChild(step);
  }

  // ---------------------------------------------------------------------------
  // Actions
  // ---------------------------------------------------------------------------
  function acceptAll() {
    var p = {};
    CATS.forEach(function (c) { p[c.id] = true; });
    finalize(p);
  }

  function rejectAll() {
    var p = {};
    CATS.forEach(function (c) { p[c.id] = !!c.locked; });
    finalize(p);
  }

  function saveSelection() {
    var p = Object.assign({}, state.prefs);
    CATS.forEach(function (c) { if (c.locked) p[c.id] = true; });
    finalize(p);
  }

  function finalize(p) {
    var oldStored = loadConsent();         // snapshot BEFORE overwrite
    saveConsent(p);
    state.prefs = p;
    state.hasConsent = true;
    state.open = false;
    cleanupDowngrades(oldStored, p);       // v2.1: wipe cookies of revoked categories
    applyConsent(p);
    // v2.2: Shopify pixel sandbox re-creates _fbp ~7ms after wipe.
    // Schedule a second cleanup pass to catch the resurrected cookies.
    try {
      setTimeout(function () { cleanupDowngrades(oldStored, p); }, 1500);
      setTimeout(function () { cleanupDowngrades(oldStored, p); }, 3500);
    } catch (e) { /* swallow */ }
    render();
    if (window.location.hash === REOPEN_HASH) {
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } catch (e) { /* swallow */ }
    }
  }

  function openCard(step) {
    state.step = step || 'main';
    state.open = true;
    render();
  }

  // ---------------------------------------------------------------------------
  // Privacy policy URL (set in snippet via window.__mkPrivacyHref)
  // ---------------------------------------------------------------------------
  function getPrivacyHref() {
    if (typeof window.__mkPrivacyHref === 'string' && window.__mkPrivacyHref.length) {
      return window.__mkPrivacyHref;
    }
    return '/policies/privacy-policy';
  }

  // ---------------------------------------------------------------------------
  // Hash handler — #cookie-settings opens settings step
  // ---------------------------------------------------------------------------
  function handleHash() {
    if (window.location.hash === REOPEN_HASH) openCard('settings');
  }

  // ---------------------------------------------------------------------------
  // Keyboard (Esc)
  // Only closes if user already has a recorded consent — pre-consent stays modal.
  // ---------------------------------------------------------------------------
  function onKeyDown(e) {
    if (e.key === 'Escape' && state.open && state.hasConsent) {
      state.open = false;
      render();
    }
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------
  function init() {
    var stored = loadConsent();
    if (stored) {
      state.hasConsent = true;
      state.prefs = prefsFromStored(stored);
      // Re-apply on every page load so GTM + Shopify API stay in sync
      applyConsent(state.prefs);

      // v2.3: Shopify pixel sandbox re-creates _fbp on EVERY page load,
      // regardless of stored consent. Wipe vendor cookies whose category
      // is currently denied. Schedule multiple passes to win the race.
      var pseudoOld = {};
      Object.keys(COOKIE_MAP).forEach(function (cat) { pseudoOld[cat] = true; });
      try {
        cleanupDowngrades(pseudoOld, state.prefs);
        setTimeout(function () { cleanupDowngrades(pseudoOld, state.prefs); }, 800);
        setTimeout(function () { cleanupDowngrades(pseudoOld, state.prefs); }, 2000);
      } catch (e) { /* swallow */ }
    }

    if (!state.hasConsent) {
      // Delay avoids layout jank during initial page paint
      setTimeout(function () {
        if (!state.open) openCard('main');
      }, 600);
    } else {
      render(); // show reopen badge
    }

    handleHash();
    window.addEventListener('hashchange', handleHash);
    window.addEventListener('keydown', onKeyDown);

    // Public API for debugging and external triggers
    window.MaskalCookies = {
      open:         function () { openCard('main'); },
      openSettings: function () { openCard('settings'); },
      getConsent:   function () { return loadConsent(); },
      reset: function () {
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* swallow */ }
        state.hasConsent = false;
        state.prefs = defaultPrefs();
        openCard('main');
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());